import { Link } from "react-router-dom";
import { usePageMetadata } from "../lib/page-metadata";

export function NotFoundPage() {
  usePageMetadata("页面不存在 · Yukai Recipes", "这个链接不存在或已经更新。");
  return (
    <section className="state-card">
      <p className="eyebrow">404</p>
      <h1>没有找到这个页面</h1>
      <p>链接可能已经更新。你可以回到菜谱库重新选择。</p>
      <Link className="button" to="/">返回菜谱库</Link>
    </section>
  );
}
